export const coursesDescription =
  'Engage, learn and apply skills quickly by taking a Course designed to teach a set of specific skills based on your topic of interest.*';

export const quickCoursesDescription =
  'Engage, learn and apply skills quickly by taking a QuickCourse designed to teach a set of specific skills based on your topic of interest.*';

export const quickSkillsDescription =
  'Build the skills you need to do your job, while on the job! Learn a skill through step-by-step overviews by a professional chef using proper techniques.';
